import { ApiStatuses } from '../../../../global/models/api-model';
import { ListItem } from '../../../../search/search-model';

export enum OfficerAdminStateActions {
	SET_INSTITUTION_OFFICERS = 'SET_INSTITUTION_OFFICERS',
	UNLOAD_INSTITUTION_OFFICERS = 'UNLOAD_INSTITUTION_OFFICERS',
	BEGIN_REQUEST_INSTITUTION_OFFICERS = 'BEGIN_REQUEST_INSTITUTION_OFFICERS',
	END_REQUEST_INSTITUTION_OFFICERS = 'END_REQUEST_INSTITUTION_OFFICERS',
	SET_GROUP_ADMINS = 'SET_GROUP_ADMINS',
	BEGIN_REQUEST_GROUP_ADMINS = 'BEGIN_REQUEST_GROUP_ADMINS',
	END_REQUEST_GROUP_ADMINS = 'END_REQUEST_GROUP_ADMINS',
	ADD_OFFICER_STATUS = 'ADD_OFFICER_STATUS',
	REINVITE_OFFICER_STATUS = 'REINVITE_OFFICER_STATUS',
	REMOVE_OFFICER_STATUS = 'REMOVE_OFFICER_STATUS',
	STAGE_OFFICER_TO_REMOVE = 'STAGE_OFFICER_TO_REMOVE',
	SET_TEMP_PASSWORD = 'SET_TEMP_PASSWORD',
}

export interface OfficerAdminState {
	officers: Officer[],
	groupAdmins: Officer[],
	officerToRemove: Officer,
	officersLoaded: boolean;
	requesting: boolean;
	groupAdminsLoaded: boolean;
	requestingGroupAdmin: boolean;
	addOfficerStatus: ApiStatuses;
	reInviteStatus: ApiStatuses;
	removeStatus: ApiStatuses;
	addAdminOfficerTempPw?: string;
}

export interface RoleObject {
	application_id: string;
	role_name: string;
	role_target: string;
	role_assignment_id: number;
	implicit: boolean;
}

export interface Officer extends ListItem {
	guid: string;
	first_name: string;
	middle_name: string;
	last_name: string;
	personal_email: string;
	business_email: string;
	business_phone: string;
	client_number: string;
	implicit: boolean;
	has_previous_invitation?: boolean;
	clergy?: boolean;
	roles?: { [key: string]: RoleObject };
}


export enum OfficerTypes {
	SeniorOfficer = 'SeniorOfficer',
	AdminOfficer = 'AdminOfficer',
	CICAdmin = 'CIC_User',
}
